export const APP_EVENTS = {
  SCENE_READY: 'scene-ready',
  CHANGE_SCENE: 'change-scene',
  ROOM_PROGRESS: 'room-progress',
  PICTURE_CLICK: 'picture-click',
  PICTURE_OVER: 'picture-over',
  SET_PROGRESS: 'set-progress',
  ACTIVE_PORTAL: 'active-portal',
  SET_HALL_ACTIVE_PORTAL: 'set-hall-active-portal',
  HALL_CAMERA_ROTATION: 'hall-camera-rotation',
  PORTAL_CLICK: 'portal-click',
  PORTAL_OVER: 'portal-over'
} as const;

export type AppEventType = typeof APP_EVENTS[keyof typeof APP_EVENTS];

export interface AppEventsBus {
  on: (event: string, callback: (data: any) => void) => void;
  off: (event: string) => void;
  emit: (event: string, data: any) => void;
  removeAllListeners?: (event: string) => void;
}

export interface AppManager {
  // Добавьте нужные поля, если они понадобятся
}

export interface App {
  appContainer: HTMLDivElement;
  appManager: AppManager;
  appEventsBus: AppEventsBus;
}

export interface AppData {
  app?: App;
}